import { render } from "./PropertyOwnerBenefitsModal.vue?vue&type=template&id=e5178f08&ts=true"
import script from "./PropertyOwnerBenefitsModal.vue?vue&type=script&lang=ts"
export * from "./PropertyOwnerBenefitsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__